import React from 'react';
import Helmet from 'react-helmet';
import { AdminLayout, AdminHeader, AdminNavbar } from '../../src/admin/layout';
import MediaGalleryContainer from '../containers/MediaGallery';
import { LimitContextProvider } from '../contexts/LimitContext';

const mediaGallery = () => {
  const header = (
    <AdminHeader title="Media Gallery" hideViewLive />
  );

  const add = {
    disabled: true,
    authorization: {},
  };

  const navbar = (
    <AdminNavbar
      add={add}
      mediaGallery={{ active: true }}
    />
  );

  return (
    <AdminLayout header={header} navbar={navbar}>
      <Helmet>
        <title>Media Gallery</title>
      </Helmet>
      <LimitContextProvider>
        <MediaGalleryContainer />
      </LimitContextProvider>
    </AdminLayout>
  );
};

export default mediaGallery;
